(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-sidebar"]) return;
  try {
    
$("document").ready(function() {
$(".collection_sidebar .child").hide();
$(".collection_sidebar .bar-block > ul > li > a").on("click", function(e) {
if($(this).next('.child').length){
$(this).next('.child').slideToggle();
return false;
}
});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-blog"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {
$(".blog-slider").slick({
responsive: [
{
breakpoint: 9999,
settings: "unslick"
},
{
breakpoint: 749,
settings: {
autoplay: true,
arrows: false,
dots:true,
}
}
]
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-keyvisual"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {
$(".top_key_visual .bg_slider").slick({
autoplay: true,
arrows: false,
dots:true,
fade:true,
speed: 2000,
});
var scroll_trigger = '.animation';
var sc_height = $(window).height() / 5 ;

$(scroll_trigger).addClass("sc_animation");

if ($(scroll_trigger).length) {
scrollAnimation();
}

function scrollAnimation() {
$(scroll_trigger).each(function () {
position = $(this).offset().top,
scroll = $(window).scrollTop(),
windowHeight = $(window).height();

if (scroll > position - windowHeight - sc_height) {
$(this).addClass('is-animated');
}
});
}

$(window).scroll(function () {
scrollAnimation();
});

$(window).trigger('scroll');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-recommend"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {
$(".recommend.productsList .content").slick({
autoplay: true,
arrows: false,
dots:true,
speed: 1000,
slidesToShow: 3,
slidesToScroll: 1,
responsive: [
{
breakpoint: 1000,
settings: {
slidesToShow: 3
}
},
{
breakpoint: 640,
settings: {
slidesToShow: 2
}
}
]
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-slide-product"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {
var slide_num = $(".top_slide_product .slider .slide").length;
$(".top_slide_product .slider").slick({
autoplay: true,
arrows: false,
fade: true,
asNavFor: ".top_slide_product  .slider_thumb_wrap",
});

$(".top_slide_product  .slider_thumb_wrap").slick({
slidesToShow: slide_num,
asNavFor: ".top_slide_product .slider",
focusOnSelect: true,
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-sp-fixed-btn"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {

let $fixedbtn = $('.top-sp-fixed-btn');
$fixedbtn.insertBefore("#shopify-section-footer");

$(window).on( 'scroll', function () {
//スクロール位置を取得
if ( $(this).scrollTop() < $(window).height() ) {
$fixedbtn.removeClass('active');
} else {
$fixedbtn.addClass('active');
}
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-topic"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {
$(".top_topic .productsList .content").slick({
autoplay: true,
arrows: false,
dots:true,
speed: 1000,
slidesToShow: 3,
slidesToScroll: 1,
responsive: [
{
breakpoint: 1000,
settings: {
slidesToShow: 3
}
},
{
breakpoint: 640,
settings: {
slidesToShow: 2
}
}
]
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-voice"] && !Shopify.designMode) return;
  try {
    
$("document").ready(function() {
$(".top_voice .content").slick({
autoplay: false,
arrows: false,
dots:true,
speed: 1000,
centerPadding: '16px',
centerMode: true,
slidesToShow: 4,
slidesToScroll: 1,
responsive: [
{
breakpoint: 1300,
settings: {
slidesToShow: 3
}
},
{
breakpoint: 1000,
settings: {
slidesToShow: 2
}
},
{
breakpoint: 640,
settings: {
slidesToShow: 1
}
}
]
});
});

  } catch(e) { console.error(e); }
})();
})();
